<template>
    <div class="app-main goods-list">

        <div class="top-bar">
            <el-input placeholder="输入商品名称或者条形码" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-radio-group v-model="recommend" size="medium" @change="getData">
                <el-radio label="1" border>按中文排序显示</el-radio>
                <el-radio label="2" border>按英文排序显示</el-radio>
            </el-radio-group>
        </div>
        
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column label="商品图片" fixed align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url"  />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center"  show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="name"  label="商品类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_type == 2">食品类型</span>
                        <span v-else-if="scope.row.goods_type == 3">服务类型</span>
                        <span v-else>普通商品</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="status" align="center" label="商品状态">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.status == 1">已上架</el-link>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="updated_at"  align="center" label="操作时间" ></el-table-column> -->
                <el-table-column prop="visits"      align="center" :label="recommend == 1 ? '中文浏览量' : '英文浏览量' " ></el-table-column>
                <el-table-column  prop="sales_volume" align="center" label="商品销量"></el-table-column>
                <el-table-column  prop="hot_sale" align="center" label="中文商品排序" v-if="recommend == 1">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort" @change="onSort(scope.row)" size="mini" style="width:65px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column  prop="hot_sale" align="center" label="英文商品排序" v-else>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort_en" @change="onSort(scope.row)" size="mini" style="width:65px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" >
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button  @click="onDelete(scope.row.goods_columns_id, scope.$index)" type="danger" plain size="mini">移除商品</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="20" ></el-pagination>
        </el-card>



    </div>
</template>



<script>
/* eslint-disable */
import { goods_columns_list, put_columns, del_columns } from '@/api/goods.js'
import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            total:0,
            page:1,
            recommend: '1'
        }
    },
    methods: {

        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
                column: 3,
                lang_sort: this.recommend
            }
            if(this.value != ""){
                params.search = this.value;
            }
            goods_columns_list(params).then(res => {
                console.log()
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },

        // 修改排序
        onSort(row){
            if(row.hot_sale == 0) {
                this.$message.error('排序不能为 0')
                return false
            }
            let params = {}
            if(this.recommend == '1') {
               params.sort = row.sort
            } else {
                params.sort_en = row.sort_en
            }
            put_columns(row.goods_columns_id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    if(this.recommend == '1') {
                        this.tableData = this.$.sortBy(this.tableData, (it) => {
                            return -it.sort
                        })
                    } else {
                        this.tableData = this.$.sortBy(this.tableData, (it) => {
                            return -it.sort_en
                        })
                    }
                    // this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            })
        },

        // 移除为您推荐
        onDelete(id, index) {
            del_columns(id).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.tableData.splice(index, 1)
                }else{
                    this.$message.error(res.msg)
                }
            })
        }
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>
<style lang="less" scoped>
@import "@/untils/public.less";
.goods-list {
    /deep/ .el-input--mini .el-input__inner{
        text-align: center;
    }
}
</style>


